import $ from 'jquery';
import 'slick-carousel';

function imagesWithTextOverlaySlider() {
	let slides = $('.images-with-text-overlay-slider .slides');

	if (slides.length && slides.find('.slide-2').length) {
		slides.not('.slick-initialized').slick({
			arrows: false,
			autoplay: true,
			autoplaySpeed: 7500,
			dots: false,
			pauseOnHover: false,
			pauseonFocus: false,
			speed: 1000,
		});
	}
}

$(window).on('load resize', function () {
	imagesWithTextOverlaySlider();
});
